{
  "columns": [
    {
      "fieldName": "hsnOrSacCode",
      "displayName": "HSN/SAC Code",
      "dataType": "STRING"
    },
    {
      "fieldName": "chargeCode",
      "displayName": "Charge Code",
      "dataType": "STRING"
    },
    {
      "fieldName": "chargeName",
      "displayName": "Charge Name",
      "dataType": "CLICKABLE",
      "thStyleConfig": {
        "width": "150px"
      },
      "styleConfig": {
        "type": "hyper-link"
      }
    },
    {
      "fieldName": "printName",
      "displayName": "Print Name",
      "dataType": "STRING"
    },
    {
      "fieldName": "description",
      "displayName": "Charge Description",
      "dataType": "STRING"
    },
    {
      "fieldName": "amount",
      "displayName": "Charge Amount",
      "dataType": "NUMBER"
    },
    {
      "fieldName": "discountPercentage",
      "displayName": "Discount(%)",
      "dataType": "NUMBER"
    },
    {
      "fieldName": "discount",
      "displayName": "Discounted Amt",
      "dataType": "NUMBER"
    },
    {
      "fieldName": "cgst",
      "displayName": "CGST",
      "dataType": "NUMBER"
    },
    {
      "fieldName": "sgst",
      "displayName": "SGST",
      "dataType": "NUMBER"
    },
    {
      "fieldName": "igst",
      "displayName": "IGST",
      "dataType": "NUMBER"
    },
    {
      "fieldName": "totalAmount",
      "displayName": "Total",
      "dataType": "NUMBER"
    }
  ]
}
